import u from '@/utils'
import axios from 'axios'

const state = {
  emailTemplatesLoading: false,
  emailTemplates: []
}

const getters = {
  getEmailTemplates() {
    return state.emailTemplates
  }
}

const mutations = {
  setEmailTemplatesLoading(state, isLoading) {
    state.emailTemplatesLoading = isLoading
  },

  setEmailTemplates(state, emailTemplates) {
    state.emailTemplates = emailTemplates
  },

  updateEmailTemplate(state, emailTemplate) {
    let index = state.emailTemplates.findIndex(
      item => item.hexId === emailTemplate.hexId
    )
    state.emailTemplates.splice(index, 1, emailTemplate)
  }
}

let actions = {
  async fetchEmailTemplates({ commit }) {
    commit('setEmailTemplatesLoading', true)
    let response = await axios.get('/api/v1/emailTemplates')
    let emailTemplates = [...response.data._embedded.emailTemplates]
    emailTemplates = emailTemplates.map(honeyForm => u.processResp(honeyForm))
    commit('setEmailTemplates', emailTemplates)
    commit('setEmailTemplatesLoading', false)
    return emailTemplates
  },

  async fetchEmailTemplate({ commit }, hexId) {
    let response = await axios.get(`/api/v1/emailTemplates/${hexId}`)
    response.data = u.processResp(response.data)
    commit('updateEmailTemplate', response.data)
    return response.data
  },

  async updateEmailTemplate({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/emailTemplates/${hexId}`, body)
    response.data = u.processResp(response.data)
    commit('updateEmailTemplate', response.data)
    return response.data
  },

  async deleteEmailTemplate(context, hexId) {
    await axios.delete(`/api/v1/emailTemplates/${hexId}`)
  },

  async saveEmailTemplate(context, emailTemplateBody) {
    let response = await axios.post('/api/v1/emailTemplates', emailTemplateBody)
    return response.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
